<template>
  <div>
    <b-input
        v-if="editMode"
        ref="input"
        type="text"
        class="inp"
        v-model="name"
        @blur="changeProfileName"
        @keyup.enter.native="changeProfileName"
        @keyup.esc.native="cancelEdit">
    </b-input>
    <span v-else @click="edit">
      <span>{{profileName}}</span>
    </span>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "slicing-profile-name",
    data() {
      return {
        name: "",
        editMode: false,
      }
    },
    props: ['profileId', 'profileName'],
    methods: {
      ...mapActions(['updateProfileName']),

      edit() {
        this.name = this.profileName;
        this.editMode = true;
        this.$nextTick(() => {
          this.$refs.input.focus();
          this.$refs.input.select();
        });
      },

      cancelEdit() {
        this.editMode = false;
        this.name = this.profileName;
      },

      changeProfileName() {
        if (this.name !== this.profileName) {
          this.updateProfileName({profileId: this.profileId, profileName: this.name}).then(data => {
            if (!data.result) {
              this.msgBoxOk('Failed to rename profile name: ' + data.message);
            }
          });
        }
        this.editMode = false;
      }
    },
    watch: {
      profileName: function(val) {
        this.name = val;
      }
    }
  }
</script>
